<template>
  <div class="proposta-anexos">
    <h2>
      Listagem de anexos da proposta n° {{ proposta.municipioPropostaId }}
    </h2>

    <hr />

    <h4>Minuta do Contrato</h4>
    <v-data-table
      :headers="headersMinuta"
      :items="minutas"
      class="elevation-1 w-100 proposta-anexos__table"
      hide-default-footer
      disable-pagination
      item-key="municipioPropostaId"
    >
      <template v-slot:item.acoes="{ item }">
        <div class="proposta-anexos__enviar">
          <v-file-input
            accept="application/pdf, application/vnd.ms-excel"
            label="Trocar minuta do contrato"
            v-model="proposta.minuta"
            hide-details="auto"
          >
          </v-file-input>
          <v-btn color="primary" class="mr-3" @click="trocarMinuta">
            Enviar
          </v-btn>
        </div>
      </template>
      <template v-slot:item.download="{ item }">
        <v-btn color="primary" class="mr-3" @click="downloadMinuta(item)">
          Download Minuta
        </v-btn>
      </template>
    </v-data-table>

    <hr />
    <div class="proposta-anexos__anexos">
      <h4>Anexos</h4>
      <div class="proposta-anexos__anexos__add">
        <NovoAnexo :payload="payload" @reload="$emit('reload')">
          <template v-slot:title> Adicionar Anexo </template>
        </NovoAnexo>
      </div>
    </div>

    <v-data-table
      :headers="headers"
      :items="anexos"
      class="elevation-1 w-100 proposta-anexos__table"
      hide-default-footer
      disable-pagination
      item-key="municipioPropostaId"
    >
      <template v-slot:item.download="{ item }">
        <v-btn color="primary" class="mr-3" @click="downloadAnexos(item)">
          Download Anexo
        </v-btn>
      </template>
      <template v-slot:item.acoes="{ item }">
        <ModalDeleteAnexo :payload="item" @reload="$emit('reload')">
          <template v-slot:title> Deletar Anexo </template>
        </ModalDeleteAnexo>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import ModalDeleteAnexo from "./modalDeleteAnexo.vue";
import NovoAnexo from "./NovoAnexo.vue";
import { mapActions, mapGetters } from "vuex";
import { propostaApi, municipioPropostaAnexoAPI } from "@/apis/proposta";
import moment from "moment";

export default {
  name: "AnexosList",
  components: {
    NovoAnexo,
    ModalDeleteAnexo,
  },
  props: {
    payload: { type: Object, required: true },
    municipio: { type: Object, required: true },
  },
  watch: {
    payload: {
      handler(val) {
        this.proposta = val;
        this.minutas = [
          {
            nomeDoArquivo: val.nomeArquivo,
            municipioPropostaId: val.municipioPropostaId,
            dataCriacao:
              val.dataEnvioMinuta &&
              moment(val.dataEnvioMinuta).format("DD/MM/YYYY"),
          },
        ];
      },
      deep: true,
    },
  },
  data() {
    return {
      proposta: this.payload,
      minutas: [
        {
          nomeDoArquivo: this.payload.nomeArquivo,
          municipioPropostaId: this.payload.municipioPropostaId,
          dataCriacao:
            this.payload.dataEnvioMinuta &&
            moment(this.payload.dataEnvioMinuta).format("DD/MM/YYYY"),
        },
      ],
      headers: [
        { text: "Nome", value: "nomeDoArquivo" },
        { text: "Descrição", value: "description" },
        { text: "Data de criação", value: "dataCriacao", width: "10%" },
        { text: "Download", value: "download", width: "10%", align: "center" },

        { text: "Excluir", value: "acoes", align: "center", width: "10%" },
      ],
      headersMinuta: [
        { text: "Nome", value: "nomeDoArquivo" },
        { text: "Data de criação", value: "dataCriacao", width: "10%" },
        { text: "Download", value: "download", width: "10%", align: "center" },
        { text: "Ações", value: "acoes", align: "center" },
      ],
    };
  },
  computed: {
    ...mapGetters(["user"]),
    anexos() {
      if (
        this.payload &&
        this.payload.municipioPropostaAnexoDTO &&
        this.payload.municipioPropostaAnexoDTO.length > 0
      )
        return this.payload.municipioPropostaAnexoDTO.map((item) => ({
          nomeDoArquivo: item.nomeArquivo,
          description: item.descricao,
          dataCriacao: moment(item.createdAt).format("DD/MM/YYYY"),
          municipioPropostaAnexosId: item.municipioPropostaAnexosId,
        }));

      return [];
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    fazerDownloadRelatorio(file, nomeArquivo) {
      var fileURL = window.URL.createObjectURL(new Blob([file]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", `${nomeArquivo}`);
      fileLink.target = "_blank";
      document.body.appendChild(fileLink);
      fileLink.click();
      this.setLoading(false);
    },
    downloadMinuta(item) {
      this.setLoading(true);
      propostaApi
        .downloadMinutaAssinada(item.municipioPropostaId)
        .then((data) => {
          this.fazerDownloadRelatorio(
            data.data,
            `Minuta do Contrato - ${this.municipio.nome} - ${item.nomeDoArquivo}`
          );

          this.$emit("onLoad");
        })
        .catch((err) => {
          this.$notification.error(
            "Erro ao fazer download da minuta do contrato"
          );
          console.log("Erro no delete ", err);
          this.setLoading(false);
        });
    },
    downloadAnexos(item) {
      this.setLoading(true);
      municipioPropostaAnexoAPI
        .downloadAnexo(item.municipioPropostaAnexosId)
        .then((data) => {
          this.fazerDownloadRelatorio(
            data.data,
            `Anexo da Proposta - ${this.municipio.nome} - ${item.nomeDoArquivo}`
          );

          this.$emit("onLoad");
        })
        .catch((err) => {
          this.$notification.error("Erro ao fazer download do anexo");
          console.log("Erro no delete ", err);
          this.setLoading(false);
        });
    },
    trocarMinuta() {
      this.setLoading(true);
      let formData = new FormData();

      formData.append("minuta", this.proposta.minuta);
      formData.append("municipioPropostaId", this.proposta.municipioPropostaId);
      formData.append("municipioId", this.proposta.municipioId);
      formData.append("usuarioEnvioMinuta", this.user.usuarioId);

      propostaApi
        .enviarAnexo(formData)
        .then((_) => {
          this.$emit("reload");
        })
        .catch((err) => {
          this.$notification.error("Erro ao salvar anexo");
          console.log("Erro no salvar anexo ", err);
          this.setLoading(false);
        });
    },
  },
};
</script>
<style lang="scss">
.proposta-anexos {
  &__table {
    th {
      background-color: #6c6b6b !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.proposta-anexos {
  padding: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 20px;

  &__anexos {
    display: flex;
    column-gap: 10px;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    &__add {
      margin-left: auto;
    }
  }
  &__enviar {
    display: flex;
    column-gap: 10px;
    padding: 10px;
    align-items: center;
    width: 100%;
    max-width: 600px;
    margin-left: auto;
  }
}
</style>
